module.exports = __webpack_public_path__ + "img/mobileApp.cee29d38.svg";